import {
  FormattedDate,
  EfsMelcoEfsModelsRun,
  EfsMelcoEfsModelsRunJob,
} from "melco-shared-logic";
import { Table } from "melco-ui";
import { useTranslation } from "react-i18next";
import { LogJobDownloadButton } from "./LogJobDownloadButton";

type LogJobListProps = {
  log: EfsMelcoEfsModelsRun;
};

export const LogJobsList: React.FC<LogJobListProps> = ({ log }) => {
  const { t } = useTranslation();

  const { job_list: jobList } = log;

  const columns = [
    {
      title: t("log_jobs_list.columns.id"),
      key: "id",
      dataIndex: "id",
    },
    {
      title: t("log_jobs_list.columns.identifier"),
      key: "job_name",
      dataIndex: "job_name",
    },
    {
      title: t("log_jobs_list.columns.start_time"),
      key: "start_time",
      dataIndex: "start_time",
      render: (_: string, item: EfsMelcoEfsModelsRunJob) => (
        <FormattedDate date={item.start_time} />
      ),
    },
    {
      title: t("log_jobs_list.columns.end_time"),
      key: "end_time",
      dataIndex: "end_time",
      render: (_: string, item: EfsMelcoEfsModelsRunJob) => (
        <FormattedDate date={item.end_time} />
      ),
    },
    {
      title: t("log_jobs_list.columns.details"),
      width: 150,
      render: (_: string, item: EfsMelcoEfsModelsRunJob) => (
        <LogJobDownloadButton logId={log.id ?? ""} jobId={item.id ?? ""} />
      ),
    },
  ];

  return (
    <Table
      sticky
      dataSource={jobList ?? []}
      columns={columns}
      pagination={false}
      rowKey="id"
      noDataMessage={t("log_jobs_list.empty")}
    />
  );
};
